export default "__VITE_ASSET__WBcJ4nmy__"